import { memo, useContext } from "react"
import { useParams } from "react-router-dom"
import { IconArrowRigth, IconIoStorefront } from "theme/common/Icon.styled"
import { ICardOrderItem } from "interfaces/IOrder"
import { useTranslation } from "react-i18next"
import { cardOrderItemStyle } from "overrides/theme/entel/base/components/Core/Order/CardOrder/CardOrderItem.styled"
import { getStatusTranslateValue } from "overrides/theme/entel/base/helpers/status_helper"
import { formatDate, formatManualTime, formatTime } from "helpers/FormatDateHelper"
import ReactTooltip from "react-tooltip"
import { PiArrowsLeftRightBold } from "react-icons/pi"
import cn from "classnames"
import { IoMdBookmark } from "react-icons/io"
import { FaCircle } from "react-icons/fa6"
import { AuthContext } from "context/context"
import { GlobalContext } from "context/context/GlobalContext"
import slotsHelper from "overrides/theme/entel/base/helpers/slots_helper"

const CardOrderItem = memo(
  ({
    id,
    orderId,
    salesChannelId,
    source,
    target,
    customer,
    orderCreationDate,
    logisticPlan,
    shippingType,
    shippingAddress,
    slotDelivery,
    orderType,
    deliveryType,
    estimatedDeliveryDate,
    _omnixStateMachine,
    custom,
    canSelect = false,
    handleClickSelectOrder,
    isCheckedOrder,
    showStatus,
    prepicking_mode,
    columns,
    handle_sg_to_prepicking,
    is_checked_to_prepick,
    currentDisplayList = "grid",
  }: ICardOrderItem) => {
    const {
      state: { user },
    } = useContext(AuthContext)
    const { schedules } = useContext(GlobalContext)
    const { t } = useTranslation()
    const { shippingtype: shippingtype_param }: any = useParams()
    let paramType = _omnixStateMachine?.currentState?.state?.id as string
    paramType = paramType?.toLocaleLowerCase()
    let shipping_type: string = shippingtype_param || shippingType?.toLocaleLowerCase()
    const infoSgToPrint = { id, orderId, source, target }

    const is_chile = user?.timezone === "America/Santiago"
    const is_peru = user?.timezone === "America/Lima"

    const _slotDelivery = slotsHelper(schedules?.state, {
      deliveryType,
      logisticPlan,
      slotDelivery,
    })

    const get_mark_on_delivered_closed_orders = () => {
      const isDelivered = paramType?.toLocaleUpperCase() === "DELIVERED"
      const hasClosedOrderKey = custom?.hasOwnProperty("closedOrder")
      const notProgramado = deliveryType !== "PROGRAMADO"

      if (is_chile) {
        if (isDelivered && hasClosedOrderKey && notProgramado) {
          return custom?.closedOrder ? "border-green" : "border-red"
        }
      }

      if (is_peru) {
        if (isDelivered && hasClosedOrderKey) {
          return custom?.closedOrder ? "border-green" : "border-red"
        }
      }

      return "border-gray"
    }

    const get_color_to_bookmark = () => {
      const color = get_mark_on_delivered_closed_orders().split("-")
      switch (color[1]) {
        case "green":
          return "#008f39"
        case "red":
          return "#ff2c2c"
        default:
          return false
      }
    }

    return (
      <>
        {currentDisplayList === "list" && prepicking_mode ? (
          <div className="card-order-item__container--prepicking">
            <div className="card-order-item__container--prepicking--first-item">
              <label className="card-order-item__check-container">
                <input
                  type="checkbox"
                  id={salesChannelId}
                  name={salesChannelId}
                  onChange={(ev) => handle_sg_to_prepicking(ev)}
                  checked={is_checked_to_prepick}
                />
                <span className="card-order-item__check-checkmark"></span>
              </label>
              <div className="flex flex-row gap-2">
                {orderType === "Portabilidad" ? (
                  <span>
                    <ReactTooltip />
                    <PiArrowsLeftRightBold
                      data-tip="Portabilidad"
                      style={{ color: "#002eff", fontSize: "1.5rem", margin: "0 0.5rem 0 1rem" }}
                    />
                  </span>
                ) : (
                  <span style={{ width: "1rem", margin: "0 0.5rem" }}></span>
                )}
                <div className="">
                  <ReactTooltip />
                  <IconIoStorefront
                    data-tip={t(shippingType)}
                    className="card-order-item__header-icon"
                    color="#002eff"
                  />
                </div>
              </div>
            </div>
            <p className="card-order-item__body-card-item-value--prepicking">{salesChannelId}</p>
            <p className="card-order-item__body-card-item-value--prepicking">
              {logisticPlan?.items[0]
                ? `${logisticPlan?.items[0]?.sku} / ${logisticPlan?.items[0]?.quantity} Und.`
                : "-"}
            </p>
            <p className="card-order-item__body-card-item-value--prepicking">
              {logisticPlan?.items[1]
                ? `${logisticPlan?.items[1]?.sku} / ${logisticPlan?.items[1]?.quantity} Und.`
                : "-"}
            </p>
            <p className="card-order-item__body-card-item-value--prepicking">
              {logisticPlan?.items[2]
                ? `${logisticPlan?.items[2]?.sku} / ${logisticPlan?.items[2]?.quantity} Und.`
                : "-"}
            </p>
            <p className="card-order-item__body-card-item-value--prepicking">
              {logisticPlan?.items[3]
                ? `${logisticPlan?.items[3]?.sku} / ${logisticPlan?.items[3]?.quantity} Und.`
                : "-"}
            </p>
          </div>
        ) : (
          <div
            className={cn({
              "card-order-item__container": Boolean(currentDisplayList === "grid"),
              "card-order-item__container card-order-item__lv__container": Boolean(currentDisplayList !== "grid"),
            })}
          >
            {get_color_to_bookmark() ? (
              <div className="card-order-item__bookmark">
                <IoMdBookmark
                  className="card-order-item__bookmark_icon"
                  style={{ color: `${get_color_to_bookmark()}`, fontSize: "2rem" }}
                />
                <FaCircle
                  className="card-order-item__circle_icon"
                  style={{ color: `${get_color_to_bookmark()}`, fontSize: "1.5rem" }}
                />
              </div>
            ) : null}
            {canSelect && (
              <div
                className={
                  currentDisplayList === "grid"
                    ? "card-order-item__content-order-checked"
                    : "card-order-item__content-order-checked card-order-item__lv__content-order-checked"
                }
              >
                <label className="card-order-item__check-container">
                  <input
                    type="checkbox"
                    id={id}
                    name={id}
                    onChange={(ev) => handleClickSelectOrder(ev, infoSgToPrint)}
                    checked={isCheckedOrder}
                  />
                  <span className="card-order-item__check-checkmark"></span>
                </label>
              </div>
            )}
            <a
              className={
                currentDisplayList === "grid"
                  ? "card-order-item__content-order-info"
                  : "card-order-item__content-order-info card-order-item__lv__content-order-info"
              }
              href={`/order/${shipping_type?.toUpperCase()}/${id}/${orderId}`}
            >
              <div
                className={
                  currentDisplayList === "grid"
                    ? "card-order-item__content-item-order"
                    : "card-order-item__content-item-order card-order-item__lv__content-item-order"
                }
              >
                <div
                  className={
                    currentDisplayList === "grid"
                      ? "card-order-item__header-card"
                      : "card-order-item__header-card card-order-item__lv__header-card"
                  }
                >
                  {orderType === "Portabilidad" ? (
                    <span>
                      <ReactTooltip />
                      <PiArrowsLeftRightBold
                        data-tip="Portabilidad"
                        style={{ color: "#002eff", fontSize: "1.2rem", margin: "0 0.5rem" }}
                      />
                    </span>
                  ) : (
                    <span style={{ width: "1rem", margin: "0 0.5rem" }}></span>
                  )}
                  <div className="card-order-item__header-left">
                    <ReactTooltip />
                    <IconIoStorefront
                      data-tip={t(shippingType)}
                      className="card-order-item__header-icon"
                      color="#002eff"
                    />
                    <p className="card-order-item__header-title">{t(shippingType)}</p>
                  </div>
                  <IconArrowRigth className="card-order-item__header-arrow" color="#002eff" />
                </div>
                <div
                  className={
                    currentDisplayList === "grid"
                      ? "card-order-item__body-card"
                      : "card-order-item__body-card card-order-item__lv__body-card"
                  }
                >
                  <div
                    className={
                      currentDisplayList === "grid"
                        ? "card-order-item__body-card-item--titles"
                        : "card-order-item__body-card-item--titles card-order-item__lv__body-card-item--titles"
                    }
                  >
                    {/* <p className="card-order-item__body-card-item-title">PORTABILIDAD</p> */}
                    {false &&
                      columns.map((col: string, i: number) => (
                        <p className="card-order-item__body-card-item-title" key={i}>
                          {col}
                        </p>
                      ))}
                    {showStatus && <p className="card-order-item__body-card-item-title">ESTADO</p>}
                  </div>
                  <div
                    className={
                      currentDisplayList === "grid"
                        ? "card-order-item__body-card-item--values"
                        : "card-order-item__body-card-item--values card-order-item__lv__body-card-item--values"
                    }
                  >
                    {/* <p className="card-order-item__body-card-item-value">
                    {orderType === "Portabilidad" ? <PiArrowsLeftRightBold style={{fontSize: "1rem"}} /> : "No"}
                  </p> */}
                    <div className="card-order-item__body-card-item-wrapper">
                      <p className="card-order-item__body-card-item-title">{columns[0]}</p>
                      <p className="card-order-item__body-card-item-value">{salesChannelId || "-"}</p>
                    </div>
                    <div className="card-order-item__body-card-item-wrapper">
                      <p className="card-order-item__body-card-item-title">{columns[1]}</p>
                      <p className="card-order-item__body-card-item-value">{deliveryType || "-"}</p>
                    </div>
                    <div className="card-order-item__body-card-item-wrapper">
                      <p className="card-order-item__body-card-item-title">{columns[2]}</p>
                      <p className="card-order-item__body-card-item-value">
                        {logisticPlan.route ? logisticPlan.route[0]?.courier?.id : "-"}
                      </p>
                    </div>
                    <div className="card-order-item__body-card-item-wrapper">
                      <p className="card-order-item__body-card-item-title">{columns[3]}</p>
                      <p className="card-order-item__body-card-item-value">{customer?.name}</p>
                    </div>
                    <div className="card-order-item__body-card-item-wrapper">
                      <p className="card-order-item__body-card-item-title">{columns[4]}</p>
                      <p className="card-order-item__body-card-item-value">
                        {formatDate(orderCreationDate || "")}, {formatTime(new Date(orderCreationDate) || "")}
                      </p>
                    </div>
                    <div className="card-order-item__body-card-item-wrapper">
                      <p className="card-order-item__body-card-item-title">{columns[5]}</p>
                      <p className="card-order-item__body-card-item-value">
                        {slotDelivery
                          ? t(
                              `${slotDelivery?.slotType} / ${formatManualTime(
                                _slotDelivery?.initial,
                              )} - ${formatManualTime(_slotDelivery?.final)}`,
                            )
                          : "-"}
                      </p>
                    </div>
                    <div className="card-order-item__body-card-item-wrapper">
                      <p className="card-order-item__body-card-item-title">{columns[6]}</p>
                      <p className="card-order-item__body-card-item-value">
                        {logisticPlan.route ? logisticPlan.route[0]?.target?.data?.criteria3 : "-"}
                      </p>
                    </div>
                    <div className="card-order-item__body-card-item-wrapper">
                      <p className="card-order-item__body-card-item-title">{columns[7]}</p>
                      <p className="card-order-item__body-card-item-value">
                        {is_peru
                          ? shippingAddress?.addressName + " " + shippingAddress?.addressNumber
                          : shippingAddress?.full_address}
                      </p>
                    </div>
                    <div className="card-order-item__body-card-item-wrapper">
                      <p className="card-order-item__body-card-item-title">{columns[8]}</p>
                      <p className="card-order-item__body-card-item-value">{formatDate(estimatedDeliveryDate || "")}</p>
                    </div>
                    <div className="card-order-item__body-card-item-wrapper">
                      <p className="card-order-item__body-card-item-title">{columns[9]}</p>
                      <p className="card-order-item__body-card-item-value">
                        <ReactTooltip />
                        <span data-tip={source?.name || ""}>{source?.id ? source?.id : "-"}</span>
                      </p>
                    </div>
                    {showStatus && (
                      <div className="card-order-item__body-card-item-wrapper">
                        <p className="card-order-item__body-card-item-title">{columns[10]}</p>
                        <p className="card-order-item__body-card-item-value">
                          {getStatusTranslateValue(paramType?.toUpperCase(), shippingType)?.title}
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </a>
          </div>
        )}
        <style jsx>{cardOrderItemStyle}</style>
      </>
    )
  },
)

export default CardOrderItem
